'use strict';

var Sugar = require('sugar-core'),
    createDate = require('./internal/createDate');

Sugar.Date.defineInstance({

  'isAfter': function(date, d, margin) {
    return date.getTime() > createDate(d).getTime() - (margin || 0);
  }

});

module.exports = Sugar.Date.isAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isAfter.js
// module id = 539
// module chunks = 0